"use client";

import { RuntimeLink } from "../../../runtime/RendererRuntime";

/**
 * "Réalisé avec" partner wordmarks shown just below the footer copyright line.
 *
 * These are fixed brand chrome (NOT CMS-managed footer data): the two partner
 * logos are static SITE assets served from the app's own `public/partners/*`
 * directory and link out to the partners' sites. Rendered small and centered so
 * they read as a discreet credit, not a content block. The logos are transparent
 * PNG/WebP that sit directly on the dark-blue footer (no chip — Pulsar's wordmark
 * is white) at full opacity, dimming only on hover.
 *
 * NOTE: a plain <img> is used on purpose, not the runtime image component. These
 * srcs are origin-relative public assets; the Next.js runtime image resolver
 * (`resolveStorageUrl`) rewrites every `/`-rooted src to the CONTENT/RESOURCE
 * bucket, which would 404 for assets that live in `public/`, not the bucket.
 */
const PARTNERS = [
  {
    name: "Pulsar Interactive",
    href: "https://pulsarinteractive.io/",
    src: "/partners/pulsar-interactive.png",
    width: 512,
    height: 97,
    imgClassName: "pt-[2px]",
  },
] as const;

export function FooterPartners({ className }: { className?: string }) {
  return (
    <div
      className={["flex flex-wrap items-center justify-center gap-x-6 gap-y-3", className]
        .filter(Boolean)
        .join(" ")}
    >
      {PARTNERS.map((partner) => (
        <RuntimeLink
          key={partner.name}
          href={partner.href}
          aria-label={partner.name}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center transition-opacity hover:opacity-80"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={partner.src}
            alt={partner.name}
            width={partner.width}
            height={partner.height}
            className={["h-5 w-auto object-contain", partner.imgClassName].filter(Boolean).join(" ")}
          />
        </RuntimeLink>
      ))}
    </div>
  );
}
